import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentFilter: "all",
  currentPageSize: 10,
  startDate: null,
  endDate: null,
  sortBy: "",
  sortOrder: "",
  search: "",
  showCreateModal: false,
  activeId: null,
  currentFormData: [null],
  activeTab: "Details",
  primary_radio_file: "",
  completedTabs: {
    Details: false,
    Uploads: false, 
  },
  CompletedPercentage: {
    Details: 0,
    Uploads: 0,
  },
  isEditData: false, 
  status : "",
  from_date: "",
  to_date: "",
  clearSelection: false,
  selectedUpdateRows: [],
  imageData: "",
  titleImageData: "",
  currentFormData: [null],
  fieldName: "",
  cropData: "",
};

const rjSlice = createSlice({
  name: "rj",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
    setStoreFormValues: (state, action) => {
      state.status= action.payload.status;
      state.from_date= action.payload.from_date;
      state.to_date= action.payload.to_date;
    },
    resetExtraFilters: (state, action) => {
      state.status= '';
      state.from_date= '';
      state.to_date= '';
    },
  },
});

export const { updateConfig, setStoreFormValues,resetExtraFilters } = rjSlice.actions;

export default rjSlice.reducer;
